import {
  faBackward,
  faBars,
  faRefresh,
  faSignOut,
  faUserEdit,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import useFetch from "../hook/useFetch";
import { userActions } from "../store/user-slice";
import InfoIcon from "./InfoIcon";
import { useContext } from "react";
import RefreshContext from "../hook/RefreshContext";

export default function Header({ onMenuToggle, isMenuOpen = false }) {
  const { update } = useFetch();
  let user = useSelector((state) => state.user.user);

  let dispatch = useDispatch();
  let navigate = useNavigate();
  let isAdmin = useSelector((state) => state.user.isAdmin);

  const refreshContext = useContext(RefreshContext);

  let cartItems = useSelector((state) => state.order.cartOrders);

  let totalCartPrice = useSelector((state) => state.order.cartItemsTotalPrice);

  return (
    <header className="header app-header">
      <div className="header-actions header-navigation">
        <button
          type="button"
          className="btn btn-primary mobile-menu-toggle"
          aria-label={isMenuOpen ? "Close navigation" : "Open navigation"}
          aria-controls="app-sidebar"
          aria-expanded={isMenuOpen}
          onClick={onMenuToggle}
        >
          <InfoIcon icon={faBars} /> <span className="button-label">Menu</span>
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => {
            navigate(-1);
          }}
        >
          <InfoIcon icon={faBackward} /> <span className="button-label">Return</span>
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary"
          disabled={refreshContext?.refreshing}
          aria-busy={refreshContext?.refreshing || false}
          onClick={() => refreshContext?.refresh()}
        >
          <InfoIcon icon={faRefresh} className={refreshContext?.refreshing ? "fa-spin" : undefined} /> <span className="button-label" aria-live="polite">{refreshContext?.refreshing ? "Aktualisiere …" : "Refresh"}</span>
        </button>
      </div>
      <div className="header-actions header-account">
        {!isAdmin && cartItems && cartItems.length > 0 && (
          <Link to="/cart" className="btn btn-outline-secondary bgnt cart-summary">
            <span>Checkout: {cartItems.length}</span>
            <span>{totalCartPrice} €</span>
          </Link>
        )}
        {user && (
          <div className="profile-summary">
            <Link to={isAdmin ? "/admin/profile" : "/profile"} aria-label={`Profile of ${user.username}`}>
              <InfoIcon size="xl" title="profile" icon={faUserEdit} />
              <span>Hallo {user.username}</span>
            </Link>
          </div>
        )}
        <button
          className="btn btn-outline-secondary"
          type="button"
          onClick={() => {
            update(
              "/user/logout",
              {},
              null,
              () => {
                dispatch(userActions.setUser(null));

                navigate("/login");
              },
            );
          }}
        >
          <InfoIcon icon={faSignOut} />
          <span className="button-label">Logout</span>
        </button>
      </div>
    </header>
  );
}
